import { Component, OnInit } from '@angular/core';

import { Observable, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';

import { IAuroraState } from '@apps/aurora.state';
import * as fromBackStore from '@apps/back/store';
import { Entity } from '@apps/auth/domain/models/back';
import { BackAuthEntitiesExternalODataRequested, BackAuthEntitiesExternalQsWordImpeSet } from '@apps/back/store/auth/entities/external/entities-external.actions';

@Component({
    selector: 'aa-impe-entities-list',
    templateUrl: './impe-entities-list.component.html',
    styleUrls: [
        './impe-entities-list.component.scss'
    ],
    standalone: false
})
export class ImpeEntitiesListComponent implements OnInit
{
    public entities: Observable<Entity[]> = of(null);
    public selectedId: Observable<string> = null;
    public isEmpty: Observable<boolean> = of(false);
    public isLoading: Observable<boolean> = of(true);
    public isLoaded: Observable<boolean> = of(false);

    constructor (
        private store: Store<IAuroraState>
    )
    { }

    ngOnInit ()
    {
        this.store.dispatch(
            BackAuthEntitiesExternalODataRequested()
        );

        this.entities = this.store
            .pipe(
                select(fromBackStore.getEntitiesExternalImpePipelined)
            );
        this.isLoading = this.store
            .pipe(
                select(fromBackStore.getEntitiesExternalLoadingStatus)
            );
        this.isLoaded = this.store
            .pipe(
                select(fromBackStore.getEntitiesExternalLoadedStatus)
            );
        this.isEmpty = this.entities
            .pipe(
                map((items: Entity[]) =>
                    items.length === 0
                )
            );

        this.selectedId = this.store.select(fromBackStore.getSelectedEntity)
            .pipe(
                filter(entity => !!entity),
                map(entity => entity.id)
            );
    }

    entityIdTrackFn = (_: number, entity: Entity) => entity.id;

    onQsWordChanged (qsWordImpe: string)
    {
        this.store.dispatch(BackAuthEntitiesExternalQsWordImpeSet({ qsWordImpe }));
    }
}
